module.exports = __webpack_public_path__ + "media/images/roku/link-image-2-cd67b9ec1335e23b19f2595494c4fd6f.png";